import React from 'react'
import Single from '../assets/single.png'
import Double from '../assets/double.png'
import Free from '../assets/Free.png'

const plans = [
  {
    img: Single,
    title: 'Einzel Vertrag',
    price: '33€ / Monat',
    features: ['Einmalige Vereinsaufnahme 33€', 'Keine versteckten Kosten!', 'Quartalsweise kündbar'],
    cta: 'Jetzt anmelden',
    highlight: false,
  },
  {
    img: Double,
    title: 'Partner Vertrag',
    price: '60€ / Monat',
    features: ['Einmalige Vereinsaufnahme 60€', 'Keine versteckten Kosten!', 'Quartalsweise kündbar'],
    cta: 'Jetzt anmelden',
    highlight: true,
  },
  {
    img: Free,
    title: 'Probetraining',
    price: 'Kostenlos',
    features: ['Kein Risiko', 'Einfach vorbeikommen', 'Kein Vertrag notwendig'],
    cta: 'Termin anfragen',
    highlight: false,
  },
]

const Membership = () => {
  return (
    <div id='mt' className='w-full pb-24 px-4 bg-black'>
      <div className='text-white text-center py-[6rem]'>
        <p style={{color:'#cc2200'}} className='font-bold tracking-[4px] uppercase text-sm mb-3'>Werde Mitglied</p>
        <h2 className='md:text-5xl sm:text-4xl text-3xl font-bold'>Mitgliedschaft</h2>
      </div>

      <div className='max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8'>
        {plans.map((plan) => (
          <div
            key={plan.title}
            className={`bg-white w-full shadow-xl flex flex-col p-6 my-4 rounded-2xl hover:scale-105 duration-300 transition-transform ${
              plan.highlight ? 'ring-4 ring-[#cc2200]' : ''
            }`}
          >
            <img className='w-20 mx-auto mt-[-2rem] bg-white rounded' src={plan.img} alt={plan.title} />
            <h2 className='text-2xl font-bold text-center py-6'>{plan.title}</h2>
            <p className='text-center text-4xl font-bold mb-2'>{plan.price}</p>
            <div className='mt-4 mb-6'>
              {plan.features.map((f) => (
                <p key={f} className='py-2 border-b mx-6 text-gray-600 text-sm'>
                  ✓ {f}
                </p>
              ))}
            </div>
            <a
              href='tel:+491733604737'
              className='w-[200px] rounded-xl my-4 mx-auto py-3 text-white font-bold text-center block transition-opacity duration-200 hover:opacity-90'
              style={{background:'#cc2200'}}
            >
              {plan.cta}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Membership
